// this code only in shopify theme not local so do not delete
    if ($(window).width() <= 767) {
      $('.search-mob-menu').click(function (e) {
        e.stopPropagation();
        $('body').addClass('searchbar-add');
      });
      $('.search-sidebar-close').click(function () {
        $('body').removeClass('searchbar-add');
      });
      $(document).on('click', function (event) {
        if (!$(event.target).closest('.sidebar').length) {
          $('body').removeClass('searchbar-add');
        }
      });
    }

    



    /* ========================================================================
       LIVE DATA LAYER (Shopify Storefront API)
       - Fetches all active products (paginated)
       - Transforms into the EXACT `ALL[]` record shape used by the existing logic
       - Caches in localStorage for 12 hours
       ======================================================================== */

    let ALL = [];
    let ALL_COLLECTIONS = [];
    let __MDV_DATA_READY = false;

    // -------------------- Cache --------------------
    const MDV_CACHE_KEY = 'mdv_search_all_v12';
    const MDV_CACHE_TTL_MS = 12 * 60 * 60 * 1000;
    function readCache() {
      try {
        const raw = localStorage.getItem(MDV_CACHE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        if (!parsed || !Array.isArray(parsed.data) || typeof parsed.timestamp !== 'number') return null;
        // Invalidate cache if country has changed
        if (parsed.country !== getStorefrontCountry()) return null;
        return parsed;
      } catch (e) { return null; }
    }
    function writeCache(data, collections) {
      try {
        localStorage.setItem(MDV_CACHE_KEY, JSON.stringify({
          data,
          collections: Array.isArray(collections) ? collections : [],
          timestamp: Date.now(),
          country: getStorefrontCountry()
        }));
      } catch (e) { }
    }
    function isCacheFresh(c) { return !!c && Date.now() - c.timestamp < MDV_CACHE_TTL_MS; }

    // -------------------- Loading/UI gating --------------------
    function setInteractionsEnabled(on) {
      const searchBar = document.querySelector('.search-bar');
      if (!searchBar) return;

      const q = searchBar.querySelector('#q');
      if (q) q.disabled = !on;

      searchBar.querySelectorAll('input, button').forEach(el => {
        if (el === q) return;
        if (el.closest && el.closest('#ac-list')) return;
        if (el.classList && el.classList.contains('pgbtn')) return;
        if (el.classList && el.classList.contains('tab')) return;

        if (!on) {
          el.setAttribute('disabled', 'disabled');
        } else {
          el.removeAttribute('disabled');
        }
      });
    }
    function showLoading(msg) {
      const grid = document.getElementById('grid');
      const rc = document.getElementById('rc');
      const pag = document.getElementById('pag');
      const tt = document.querySelector('.search-page-title');
      const col = document.getElementById('collections');
      if (rc) rc.textContent = '';
      if (pag) pag.innerHTML = '';
      if (tt) tt.innerHTML = '<h2>Products</h2>';
      if (col) col.innerHTML = '';
      if (grid) grid.innerHTML = `<div class="loading">
    <div>
      <img src="https://cdn.shopify.com/s/files/1/0282/6678/files/navigation_animation-sidebar-brown.gif" alt="Loading" style="width:26px;height:26px;object-fit:contain" loading="eager">
    </div>
    <div>${esc(msg || 'Loading products...')} <span id="loading-count" style="display:inline-block;margin-left:8px;letter-spacing:.06em;text-transform:none;color:rgba(0,0,0,.55)"></span></div>
  </div>`;
    }
    function setLoadingCount(n) {
      const el = document.getElementById('loading-count');
      if (!el) return;
      const num = Number(n);
      if (!Number.isFinite(num) || num <= 0) { el.textContent = ''; return; }
      el.textContent = '(' + num.toLocaleString() + ' loaded)';
    }
    function showError(msg, canRetry) {
      const grid = document.getElementById('grid');
      const rc = document.getElementById('rc');
      const pag = document.getElementById('pag');
      const tt = document.querySelector('.search-page-title');
      const col = document.getElementById('collections');
      if (rc) rc.textContent = '';
      if (pag) pag.innerHTML = '';
      if (tt) tt.innerHTML = '<h2>Products</h2>';
      if (col) col.innerHTML = '';
      const btn = canRetry ? `<div style="margin-top:14px"><button class="pgbtn" onclick="boot(true)">Retry</button></div>` : '';
      if (grid) grid.innerHTML = `<div class="empty"><h2>Unable to load products</h2><p>${esc(msg || 'Please try again.')}</p>${btn}</div>`;
    }

    // -------------------- API --------------------
const STOREFRONT_URL='https://manire-de-voir-aus.myshopify.com/api/2026-01/graphql.json';
const STOREFRONT_TOKEN='a3a6aa5bd303dfb244a289fadd088b6c';
    const GQL_QUERY = `
query ($cursor: String, $country: CountryCode) @inContext(country: $country) {
  products(first: 250, after: $cursor, query: "status:active", sortKey: BEST_SELLING) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        title
        handle
        vendor
        gender: metafield(namespace:"custom", key:"gender") {
          value
        }
        productType
        tags
        description
        descriptionHtml
        collections(first: 15) {
          edges {
            node {
              handle
              title
              metafield(namespace: "custom", key: "search_collections") {
                value
              }
            }
          }
        }

        images(first: 2) {
          edges {
            node {
              url
            }
          }
        }

        priceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }

        compareAtPriceRange {
          minVariantPrice {
            amount
            currencyCode
          }
        }

        variants(first: 100) {
          edges {
            node {
              id
              sku
              availableForSale

              selectedOptions {
                name
                value
              }
            }
          }
        }
      }
    }
  }
}
`;

    function getStorefrontCountry() {
      try {
        // Get country from 'selectedCountry' cookie
        const value = `; ${document.cookie}`;
        const parts = value.split(`; selectedCountry=`);
        let c = '';
        if (parts.length === 2) {
          c = parts.pop().split(';').shift().trim();
        }
        
        // Fallback to Shopify.country if cookie is not present
        if (!c && typeof window !== 'undefined' && window.Shopify && window.Shopify.country) {
          c = String(window.Shopify.country).trim();
        }
        
        if (c && /^[A-Z]{2}$/.test(c)) return c;
      } catch (_) { }
      return null;
    }

    async function storefrontFetch(cursor, country) {
      const res = await fetch(STOREFRONT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: GQL_QUERY, variables: { cursor: cursor || null, country: country || null } })
      });
      if (!res.ok) {
        const t = await res.text().catch(() => '');
        throw new Error('Storefront API HTTP ' + res.status + (t ? (' - ' + t.slice(0, 180)) : ''));
      }
      const json = await res.json();
      if (json.errors && json.errors.length) {
        throw new Error('Storefront API error: ' + json.errors.map(e => e.message).join(' | '));
      }
      return json.data;
    }

    async function getAllProducts(onProgress) {
      let cursor = null;
      let hasNextPage = true;
      const out = [];
      const country = getStorefrontCountry();
      while (hasNextPage) {
        const data = await storefrontFetch(cursor, country);
        const conn = data && data.products;
        if (!conn || !conn.edges) break;
        for (const e of conn.edges) { if (e && e.node) out.push(e.node); }
        hasNextPage = !!(conn.pageInfo && conn.pageInfo.hasNextPage);
        cursor = conn.pageInfo && conn.pageInfo.endCursor || null;
        if (!cursor) hasNextPage = false;
        try { if (typeof onProgress === 'function') onProgress(out.length, hasNextPage); } catch (_) { }
      }
      return out;
    }

    // -------------------- Transform --------------------
    function pickFirstImageUrl(node) {
      const e = node && node.images && node.images.edges && node.images.edges[0] && node.images.edges[0].node;
      return e && e.url || '';
    }
    function pickSecondImageUrl(node) {
      const e = node && node.images && node.images.edges && node.images.edges[1] && node.images.edges[1].node;
      return e && e.url || '';
    }
    function toNum(x) {
      const n = parseFloat(x);
      return Number.isFinite(n) ? n : null;
    }
    function inferGender(node) {
      // Detect gender from vendor: "woman" anywhere → Woman; word "man" (not inside "woman") → Man; unisex → Unisex
      const v = String(node.vendor || '').trim();
      if (v) {
        if (/woman/i.test(v)) return 'Woman';
        if (/\bman\b/i.test(v)) return 'Man';
        if (/unisex/i.test(v)) return 'Unisex';
      }
      const tags = (node.tags || []).map(t => String(t || '').toLowerCase());
      const tset = new Set(tags);
      if ([...tset].some(t => t.includes('unisex'))) return 'Unisex';
      if ([...tset].some(t => t.includes('women') || t.includes('womens') || t.includes("women's") || t.includes('woman'))) return 'Woman';
      if ([...tset].some(t => t.includes('men') || t.includes('mens') || t.includes("men's") || t.includes('man'))) return 'Man';
      if (ACCESSORY_TYPES.has(node.productType)) return 'Unisex';
      return 'Unisex';
    }
    function extractColourFromTitle(title) {
      const parts = String(title || '').split(' - ').map(s => s.trim()).filter(Boolean);
      if (parts.length >= 2) return parts[parts.length - 1];
      return '';
    }
    function extractVariantOptionValues(node, optionNames) {
      const want = new Set(optionNames.map(s => String(s || '').toLowerCase()));
      const vals = [];
      const edges = node.variants && node.variants.edges || [];
      for (const e of edges) {
        const v = e && e.node; if (!v) continue;
        const opts = v.selectedOptions || [];
        for (const o of opts) {
          const n = String(o && o.name || '').toLowerCase();
          if (want.has(n)) {
            const val = String(o && o.value || '').trim();
            if (val) vals.push(val);
          }
        }
      }
      return vals;
    }
    function normaliseColourGroup(col) {
      const c = String(col || '').toLowerCase();
      if (!c) return '';
      if (c.includes('navy') || c.includes('midnight')) return 'Navy';
      if (c.includes('grey') || c.includes('gray') || c.includes('charcoal') || c.includes('marl')) return 'Grey';
      if (c.includes('black')) return 'Black';
      if (c.includes('white')) return 'White';
      if (c.includes('off white') || c.includes('off-white')) return 'Cream';
      if (c.includes('cream')) return 'Cream';
      if (c.includes('beige') || c.includes('taupe') || c.includes('stone') || c.includes('nude') || c.includes('camel') || c.includes('tan')) return 'Beige';
      if (c.includes('brown') || c.includes('chocolate') || c.includes('espresso')) return 'Brown';
      if (c.includes('blue') || c.includes('indigo')) return 'Blue';
      if (c.includes('green') || c.includes('olive') || c.includes('khaki') || c.includes('sage')) return 'Green';
      if (c.includes('red') || c.includes('burgundy') || c.includes('wine')) return 'Red';
      if (c.includes('pink') || c.includes('lilac')) return 'Pink';
      if (c.includes('purple')) return 'Purple';
      if (c.includes('silver')) return 'Silver';
      if (c.includes('gold')) return 'Gold';
      return '';
    }
    function extractSubtypesFromTitle(title) {
      const t = String(title || '').toLowerCase();
      const toks = t.split(/[^a-z]+/g).filter(Boolean);
      const out = [];
      for (const tok of toks) {
        const st = SUBTYPE_ALIASES[tok];
        if (st) out.push(st);
      }
      return [...new Set(out)];
    }
    function inferCoord(node) {
      const title = String(node.title || '').toLowerCase();
      const tags = (node.tags || []).map(t => String(t || '').toLowerCase());
      if (tags.some(t => t.includes('coord') || t.includes('co-ord') || t.includes('co ord'))) return true;
      const compact = title.replace(/[^a-z]+/g, '');
      for (const tr of COORD_TRIGGERS) { if (compact.includes(tr)) return true; }
      return false;
    }
    function normaliseSizeValue(v) {
      const s = String(v || '').trim();
      if (!s) return '';
      const up = s.toUpperCase();
      if (/^UK\s*\d+$/i.test(s)) return 'UK ' + s.replace(/[^0-9]/g, '');
      if (/^\d+$/.test(s)) {
        const n = parseInt(s, 10);
        if (n >= 3 && n <= 16) return 'UK ' + n;
        return String(n);
      }
      if (/^W\d{2}$/i.test(up)) return up;
      if (['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'].includes(up)) return up;
      return s;
    }
    function extractSizesFromVariants(node) {
      const vals = extractVariantOptionValues(node, ['size', 'uk size', 'shoe size', 'waist', 'w']);
      const norm = vals.map(normaliseSizeValue).filter(Boolean);
      return [...new Set(norm)];
    }
    function extractSkus(node) {
      const edges = node.variants && node.variants.edges || [];
      const skus = [];
      for (const e of edges) {
        const sku = e && e.node && e.node.sku;
        const n = sku ? normSKU(String(sku)) : '';
        if (n) skus.push(n);
      }
      return [...new Set(skus)];
    }
    function extractVariantModels(node) {
      const edges = node.variants && node.variants.edges || [];
      const out = [];
      for (const e of edges) {
        const v = e && e.node; if (!v) continue;
        const opts = {};
        for (const o of (v.selectedOptions || [])) {
          const k = String(o && o.name || '').toLowerCase().trim();
          const val = String(o && o.value || '').trim();
          if (k && val) opts[k] = val;
        }
        out.push({
          id: String(v.id || '').trim(),
          sku: v.sku ? normSKU(String(v.sku)) : '',
          available: !!v.availableForSale,
          opts
        });
      }
      return out;
    }
    function buildParentSkus(skus) {
      const out = new Set();
      for (const s of skus) {
        const parts = String(s).split('-').filter(Boolean);
        if (parts[0]) out.add(parts[0]);
        if (parts.length >= 2) out.add(parts[0] + '-' + parts[1]);
      }
      return [...out];
    }

    function inferTypeFromTitle(title) {
      const t = String(title || '').toLowerCase();
      // Footwear (incl. phrases used on ME store)
      if (/\b(nylon\s+runner)\b/.test(t)) return 'Footwear';
      if (/\b(boot|boots|trainer|trainers|sneaker|sneakers|loafer|loafers|heel|heels|sandal|sandals|mule|mules|slide|slides|flat|flats|pump|pumps|shoe|shoes)\b/.test(t)) return 'Footwear';
      if (/\bflats?\s+with\s+hardware\b/.test(t)) return 'Footwear';
      // Apparel first — stops "jumpsuit with belt" / "dress with belt" becoming Belts
      if (/\b(blazer|blazers)\b/.test(t)) return 'Blazers';
      if (/\b(waistcoat|waistcoats)\b/.test(t)) return 'Waistcoats';
      if (/\b(coat|coats)\b/.test(t)) return 'Coats';
      if (/\b(jacket|jackets)\b/.test(t)) return 'Jackets';
      if (/\b(hoodie|hoodies)\b/.test(t)) return 'Hoodies';
      if (/\b(jumper|jumpers|cardigan|cardigans)\b/.test(t)) return 'Jumpers & Cardigans';
      if (/\b(t-?shirt|tshirts|tees?)\b/.test(t)) return 'T-Shirts';
      if (/\b(shirt|shirts)\b/.test(t)) return 'Shirts';
      if (/\b(polo)\b/.test(t)) return 'Polo Tops';
      if (/\b(vest|vests)\b/.test(t)) return 'Vests';
      if (/\b(dress|dresses)\b/.test(t)) return 'Dresses';
      if (/\b(skirt|skirts)\b/.test(t)) return 'Skirts';
      if (/\b(legging|leggings)\b/.test(t)) return 'Leggings';
      if (/\b(jumpsuit|jumpsuits)\b/.test(t)) return 'Jumpsuits';
      if (/\b(playsuit|playsuits)\b/.test(t)) return 'Playsuits';
      if (/\b(denim|jeans)\b/.test(t)) return 'Denim';
      if (/\b(short|shorts)\b/.test(t)) return 'Shorts';
      if (/\b(trouser|trousers|pant|pants)\b/.test(t)) return 'Casual Trousers';
      if (/\b(track|tracksuit|jogger|joggers)\b/.test(t)) return 'Tracksuit Bottoms';
      // Bags (after apparel so co-ords with "clutch" etc. still resolve as clothing when dominant)
      if (/\b(bag|bags|tote|crossbody|handbag|backpack|purse|clutch|wallet)\b/.test(t)) return 'Bags';
      // Accessories — granular types (MDV collections: bags, headwear, gloves, scarves, sunglasses, ties, belts, jewellery)
      if (/\b(hat|hats|cap|caps|beanie|berets?)\b/.test(t)) return 'Headwear';
      if (/\b(scarf|scarves)\b/.test(t)) return 'Scarves';
      if (/\b(glove|gloves|mitten|mittens)\b/.test(t)) return 'Gloves';
      if (/\b(sunglass|sunglasses)\b/.test(t)) return 'Sunglasses';
      if (/\b(tie|ties|cufflink|cufflinks)\b/.test(t)) return 'Ties';
      if (/\b(belt|belts)\b/.test(t)) return 'Belts';
      if (/\b(necklace|necklaces|earring|earrings|ring|rings|jewellery|jewelry)\b/.test(t)) return 'Jewellery';
      return 'Tops';
    }

    function normaliseType(node) {
      // The store's Storefront API `productType` is not the granular "Jackets/T-Shirts/..." taxonomy
      // required by this search engine. We therefore infer a canonical type from the product title.
      const title = node && node.title || '';
      return inferTypeFromTitle(title);
    }

    function buildProductSearchBlob(node, title, type) {
      const stripHtml = (s) => String(s || '').replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
      const desc = stripHtml(node.description) || stripHtml(node.descriptionHtml);
      const coll = [];
      for (const e of (node.collections && node.collections.edges) || []) {
        const n = e && e.node; if (!n) continue;
        if (n.title) coll.push(String(n.title));
        if (n.handle) coll.push(String(n.handle).replace(/-/g, ' '));
      }
      const tagStr = (node.tags || []).map(x => String(x || '')).join(' ');
      return [title, type, String(node.vendor || ''), desc, coll.join(' '), tagStr].join(' ').toLowerCase().replace(/-/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function transformShopifyToAll(nodes) {
      const out = [];
      const collectionsByHandle = {};
      const total = nodes && nodes.length ? nodes.length : 0;
      for (let i = 0; i < (nodes || []).length; i++) {
        const node = nodes[i];
        // Collect unique collections from this product — only those flagged via custom.search_collections=true
        for (const e of (node.collections && node.collections.edges) || []) {
          const n = e && e.node;
          if (!n) continue;
          const meta = n.metafield;
          if (!meta || String(meta.value || '').toLowerCase() !== 'true') continue;
          const h = String(n.handle || '').trim();
          const tt = String(n.title || '').trim();
          if (h && tt && !collectionsByHandle[h]) collectionsByHandle[h] = { handle: h, title: tt };
        }
        const title = String(node.title || '').trim();
        const handle = String(node.handle || '').trim();
        const type = normaliseType(node);
        const image = pickFirstImageUrl(node);
        const image2 = pickSecondImageUrl(node) || image;
        const skus = extractSkus(node);
        const _variants = extractVariantModels(node);
        const colourFromTitle = extractColourFromTitle(title);
        const colours = [...new Set([
          ...extractVariantOptionValues(node, ['color', 'colour']).map(s => String(s).trim()).filter(Boolean),
          ...(colourFromTitle ? [colourFromTitle] : [])
        ])];
        const colour = colourFromTitle || colours[0] || '';
        const _search = buildProductSearchBlob(node, title, type);
        // _rank 0–100 best-selling order (approx) — aligns with original handover doc
        const _rank = total <= 1 ? 100 : Math.max(0, Math.round(100 - (i / (total - 1)) * 100));
        const priceMoney = node.priceRange && node.priceRange.minVariantPrice || {};
        const compareMoney = node.compareAtPriceRange && node.compareAtPriceRange.minVariantPrice || {};
        const productTags = Array.isArray(node.tags) ? node.tags.map(t => String(t || '').trim()).filter(Boolean) : [];
        const collectionTitles = ((node.collections && node.collections.edges) || []).map(e => e && e.node && e.node.title ? String(e.node.title).trim() : '').filter(Boolean);
        const available = _variants.some(v => v.available);
        out.push({
          title,
          handle,
          vendor: String(node.vendor || '').trim(),
          tags: productTags,collectionTitles,available,
          image,
          image2,
          gender: String(node.gender && node.gender.value ? node.gender.value : '').trim() || inferGender(node),
          type,
          colour,
          colours,
          _search,
          price_raw: String(priceMoney.amount || '').trim(),
          compare_at_raw: String(compareMoney.amount || '').trim(),
          currency_code: String(priceMoney.currencyCode || compareMoney.currencyCode || '').trim(),
          price: toNum(node.priceRange && node.priceRange.minVariantPrice && node.priceRange.minVariantPrice.amount),
          compare_at: toNum(node.compareAtPriceRange && node.compareAtPriceRange.minVariantPrice && node.compareAtPriceRange.minVariantPrice.amount),
          coord: inferCoord(node),
          subtypes: extractSubtypesFromTitle(title),
          skus,
          parent_skus: buildParentSkus(skus),
          sizes: extractSizesFromVariants(node),
          _variants,
          colour_group: normaliseColourGroup(colour),
          _rank
        });
      }
      mergeCollections(
        Object.values(collectionsByHandle)
      );
      return out;
    }
    function mergeCollections(newCollections) {

      const map = {};

      ALL_COLLECTIONS.forEach(c => {
        map[c.handle] = c;
      });

      newCollections.forEach(c => {
        map[c.handle] = c;
      });

      ALL_COLLECTIONS = Object.values(map)
        .sort((a, b) => a.title.localeCompare(b.title));
    }

    // -------------------- Boot --------------------
async function boot(forceRefetch) {
  const cached = readCache();

  if (!forceRefetch && isCacheFresh(cached)) {
    ALL = cached.data;
    ALL_COLLECTIONS = Array.isArray(cached.collections) ? cached.collections : [];
    __MDV_DATA_READY = true;
    setInteractionsEnabled(true);
    render();
    console.log('[MDV search] Loaded from cache');
    return;
  }

  const isSearchPage = window.location.pathname === '/search';
  setInteractionsEnabled(false);
  if (isSearchPage) {
    showLoading('Loading products...');
    setLoadingCount(0);
  }

  try {
     const country = getStorefrontCountry();

    /* -------------------------
      FIRST PAGE ONLY
    -------------------------- */
    const firstPage = await storefrontFetch(null, country);
    const firstNodes = firstPage.products.edges.map(e => e.node);
    ALL = transformShopifyToAll(firstNodes);
    __MDV_DATA_READY = true;
    setInteractionsEnabled(true);
    render();
    setLoadingCount(ALL.length);

    /* -------------------------
      BACKGROUND LOADING
    -------------------------- */
    let cursor = firstPage.products.pageInfo.endCursor;
    let hasNextPage = firstPage.products.pageInfo.hasNextPage;
    while (hasNextPage) {
      const nextPage = await storefrontFetch(cursor, country);
      const nextNodes = nextPage.products.edges.map(e => e.node);
      const nextProducts = transformShopifyToAll(nextNodes);
      ALL.push(...nextProducts);
      setLoadingCount(ALL.length);
      cursor = nextPage.products.pageInfo.endCursor;
      hasNextPage = nextPage.products.pageInfo.hasNextPage;
    }
    // All products loaded
    if (S.q) {
      render();
    }

    /* -------------------------
      SAVE FINAL CACHE
    -------------------------- */
    writeCache(ALL, ALL_COLLECTIONS);

  } catch (e) {
    const msg = e && e.message ? e.message : 'Failed to fetch products.';

    if (cached && cached.data && cached.data.length) {
      ALL = cached.data;
      ALL_COLLECTIONS = Array.isArray(cached.collections) ? cached.collections : [];
      __MDV_DATA_READY = true;
      setInteractionsEnabled(true);
      render();
      console.warn('[MDV search] Using old cache because GraphQL failed');
      return;
    }

    __MDV_DATA_READY = false;
    setInteractionsEnabled(false);
    showError(msg, true);
  }
}
    function initGhostSuggestion() {
        const input = document.getElementById('q');
        if (!input) return;
        if (document.querySelector('.mdv-ghost-suggestion')) return;
        const ghost = document.createElement('div');
        ghost.className = 'mdv-ghost-suggestion';
        input.parentNode.appendChild(ghost);
        window.__ghostEl = ghost;
    }

    const SUGGESTIONS = [["jacket", 3000], ["trousers", 2900], ["blazer", 2800], ["t-shirt", 2700], ["dress", 2600], ["shirt", 2500], ["hoodie", 2400], ["jeans", 2300], ["coat", 2200], ["jumper", 2100], ["shorts", 2050], ["leggings", 2000], ["mens jacket", 1950], ["womens dress", 1900], ["mens trousers", 1850], ["womens jacket", 1800], ["mens blazer", 1750], ["womens blazer", 1700], ["mens hoodie", 1650], ["womens hoodie", 1600], ["mens jeans", 1580], ["womens jeans", 1560], ["mens t-shirt", 1540], ["womens shirt", 1520], ["mens shirt", 1500], ["black blazer", 1450], ["leather jacket", 1400], ["wide leg trousers", 1350], ["tailored trousers", 1300], ["black jacket", 1250], ["black dress", 1200], ["cargo trousers", 1150], ["tailored blazer", 1100], ["black trousers", 1050], ["leather trousers", 1000], ["black t-shirt", 950], ["white shirt", 900], ["black shirt", 850], ["black hoodie", 800], ["double breasted blazer", 780], ["cropped blazer", 760], ["zip hoodie", 740], ["pleated trousers", 720], ["wide leg jeans", 700], ["satin dress", 680], ["knit dress", 660], ["mini dress", 640], ["brown jacket", 620], ["black jeans", 600], ["cropped jacket", 580], ["polo shirt", 560], ["mens polo shirt", 540], ["tailored shirt", 520], ["unisex hoodie", 490], ["womens coat", 490], ["co-ord set", 480], ["boots", 480], ["mens coat", 480], ["co-ord", 480], ["wide shoulder jacket", 460], ["trainers", 460], ["bag", 450], ["maxi dress", 440], ["sneakers", 440], ["bags", 440], ["crossbody bag", 430], ["midi dress", 420], ["loafers", 420], ["joggers", 420], ["handbag", 410], ["oversized hoodie", 400], ["heels", 400], ["white t-shirt", 400], ["tote bag", 390], ["oversized shirt", 380], ["ankle boots", 380], ["relaxed fit trousers", 380], ["ribbed top", 370], ["shoulder bag", 370], ["womens jumper", 370], ["satin top", 360], ["mens jumper", 360], ["knit top", 350], ["purse", 350], ["belt", 350], ["mens joggers", 350], ["black top", 340], ["chelsea boots", 340], ["knit jumper", 340], ["wide shoulder blazer", 340], ["white top", 330], ["leather bag", 330], ["womens joggers", 330], ["wool jumper", 320], ["relaxed fit hoodie", 320], ["wide shoulder top", 320], ["cargo pants", 310], ["backpack", 310], ["tailored jacket", 300], ["sandals", 300], ["waistcoat", 300], ["unisex t-shirt", 300], ["wool jacket", 290], ["suede jacket", 280], ["flats", 280], ["leather belt", 280], ["flared trousers", 280], ["double breasted shirt", 280], ["velvet jacket", 270], ["black leggings", 260], ["black boots", 260], ["belted trousers", 260], ["satin trousers", 260], ["mens shorts", 250], ["black trainers", 250], ["mens waistcoat", 250], ["womens shorts", 245], ["skirt", 240], ["black sneakers", 240], ["womens waistcoat", 240], ["belted coat", 240], ["leather skirt", 240], ["womens skirt", 230], ["pleated skirt", 220], ["black jumper", 220], ["mini skirt", 210], ["grey trousers", 210], ["cream dress", 210], ["jumpsuit", 200], ["black loafers", 200], ["black bag", 200], ["black belt", 200], ["brown trousers", 200], ["beige jacket", 200], ["blue jeans", 200], ["cream t-shirt", 200], ["leather handbag", 190], ["unisex jacket", 180], ["unisex shirt", 180], ["unisex joggers", 180], ["cream jeans", 180], ["black shorts", 180], ["mens shoes", 180], ["womens shoes", 180], ["necklace", 180], ["brown loafers", 170], ["satin shorts", 170], ["black skirt", 170], ["black jumpsuit", 160], ["brown dress", 160], ["black coat", 160], ["black polo shirt", 150], ["white blazer", 150], ["grey blazer", 150], ["brown blazer", 140], ["knit polo shirt", 140], ["leather shirt", 140], ["leather coat", 140], ["leather jumpsuit", 130], ["suede trousers", 130], ["suede bag", 130], ["silver necklace", 120]]; // index-derived phrases, score-ranked

    const APPAREL = new Set(['Blazers', 'Dresses', 'Jackets', 'Suit Jackets', 'Formal Trousers', 'Casual Trousers', 'T-Shirts', 'Shirts', 'Tops', 'Jumpers & Cardigans', 'Coats', 'Denim', 'Tracksuit Tops', 'Tracksuit Bottoms', 'Shorts', 'Polo Tops', 'Vests', 'Skirts', 'Swimwear', 'Jumpsuits', 'Leggings', 'Waistcoats', 'Hoodies', 'Playsuits']);
    const FOOTWEAR_TYPES = new Set(['Footwear']);
    const ACCESSORY_TYPES = new Set(['Bags', 'Belts', 'Hats', 'Headwear', 'Sunglasses', 'Jewellery', 'Ties', 'Scarves', 'Gloves', 'Cufflinks', 'Underwear']);
    const SKU_RE = /^[A-Z]{2,4}[\d.]{3,8}([-][\w./]+)*$/i;
    function isSKUQuery(q) { const n = q.trim().toUpperCase().replace(/[\s.]+/g, '-').replace(/-+/g, '-'); return SKU_RE.test(n) && /\d{3,}/.test(n); }
    function normSKU(s) { return s.trim().toUpperCase().replace(/[\s.]+/g, '-').replace(/-+/g, '-'); }
    function skuSearch(q) {
      const norm = normSKU(q);
      const exact = [], partial = []; const seen = new Set();
      for (const p of ALL) {
        if (seen.has(p.handle)) continue;
        const sk = p.skus || []; const ps = p.parent_skus || [];
        if (sk.includes(norm)) { exact.push(p); seen.add(p.handle); }
        else if (ps.includes(norm)) { partial.push(p); seen.add(p.handle); }
        else if (sk.some(s => s.startsWith(norm)) || ps.some(s => s.startsWith(norm))) { partial.push(p); seen.add(p.handle); }
      }
      return [...exact, ...partial];
    }
    const TYPE_ALIASES = {
      blazer: ['Blazers', 'Suit Jackets'], blazers: ['Blazers', 'Suit Jackets'], jacket: ['Jackets'], jackets: ['Jackets'], coat: ['Coats'], coats: ['Coats'], waistcoat: ['Waistcoats'], trousers: ['Formal Trousers', 'Casual Trousers'], trouser: ['Formal Trousers', 'Casual Trousers'], pants: ['Formal Trousers', 'Casual Trousers', 'Tracksuit Bottoms'], denim: ['Denim'], dress: ['Dresses'], dresses: ['Dresses'], skirt: ['Skirts'], top: ['Tops', 'T-Shirts', 'Polo Tops'], tops: ['Tops', 'T-Shirts', 'Polo Tops'], tshirt: ['T-Shirts'], 't-shirt': ['T-Shirts'], 't-shirts': ['T-Shirts'], tshirts: ['T-Shirts'], tee: ['T-Shirts'], tees: ['T-Shirts'], shirt: ['Shirts'], shirts: ['Shirts'], hoodie: ['Tracksuit Tops', 'Hoodies'], hoodies: ['Tracksuit Tops', 'Hoodies'], tracksuit: ['Tracksuit Tops', 'Tracksuit Bottoms'], joggers: ['Tracksuit Bottoms'], jumper: ['Jumpers & Cardigans'], cardigan: ['Jumpers & Cardigans'], bodysuit: ['Tops'], jumpsuit: ['Jumpsuits'], leggings: ['Leggings'], bag: ['Bags'], bags: ['Bags'], belt: ['Belts'], belts: ['Belts'], cap: ['Hats', 'Headwear'], hat: ['Hats', 'Headwear'], necklace: ['Jewellery'], ring: ['Jewellery'], earrings: ['Jewellery'], boots: ['Footwear'], boot: ['Footwear'], heels: ['Footwear'], heel: ['Footwear'], trainers: ['Footwear'], trainer: ['Footwear'], sneakers: ['Footwear'], sneaker: ['Footwear'], sandals: ['Footwear'], sandal: ['Footwear'], flat: ['Footwear'], flats: ['Footwear'], loafers: ['Footwear'], loafer: ['Footwear'], shoe: ['Footwear'], shoes: ['Footwear'], pump: ['Footwear'], pumps: ['Footwear'], mule: ['Footwear'], slide: ['Footwear'],
      skirts: ['Skirts'], shorts: ['Shorts'], jeans: ['Denim'],
      jumpers: ['Jumpers & Cardigans'], cardigans: ['Jumpers & Cardigans'],
      vests: ['Vests'], skirt: ['Skirts'],
      necklaces: ['Jewellery'], rings: ['Jewellery'], earring: ['Jewellery'],
      mules: ['Footwear'], slides: ['Footwear'],
      purse: ['Bags'], handbag: ['Bags'], handbags: ['Bags'], purses: ['Bags'], wallet: ['Bags'], wallets: ['Bags'],
      corset: ['Tops'], corsets: ['Tops'],
      legging: ['Leggings'], short: ['Shorts'],
      polo: ['Polo Tops'], polos: ['Polo Tops'], vest: ['Vests'],
      jumpsuit: ['Jumpsuits'], jumpsuits: ['Jumpsuits'],
      bodysuits: ['Tops'], jogger: ['Tracksuit Bottoms'],
      accessory: ['Bags', 'Belts', 'Hats', 'Headwear', 'Sunglasses', 'Jewellery', 'Ties', 'Scarves'],
      accessories: ['Bags', 'Belts', 'Hats', 'Headwear', 'Sunglasses', 'Jewellery', 'Ties', 'Scarves']
    };
    const STOP = new Set(['for', 'a', 'an', 'the', 'to', 'in', 'on', 'at', 'of', 'with', 'something', 'nice', 'clean', 'going', 'out', 'dinner', 'night', 'minimal', 'date', 'all', 'very', 'really', 'some', 'look', 'collection', 'pls', 'please', 'maybe', 'gift', 'random', 'xyz', 'everyday', 'good', 'want', 'i', 'my', 'size']);
    const GENDER_TOKENS = { womenswear: 'Woman', menswear: 'Man', "women's": 'Woman', "men's": 'Man', womens: 'Woman', womans: 'Woman', mens: 'Man', women: 'Woman', men: 'Man', woman: 'Woman', man: 'Man' };
    const INTENT = new Set(['office', 'work', 'smart', 'formal', 'casual', 'evening', 'party', 'holiday', 'gym', 'running', 'occasion', 'wedding', 'outfit', 'wear', 'style', 'matching']);
    const TYPOS = { lether: 'leather', letheer: 'leather', leater: 'leather', blak: 'black', blcak: 'black', bkack: 'black', blck: 'black', trusers: 'trousers', trousrs: 'trousers', trouses: 'trousers', trousesr: 'trousers', trowsers: 'trousers', trosuers: 'trousers', trroussers: 'trousers', blazor: 'blazer', blaser: 'blazer', blazr: 'blazer', blzr: 'blazer', blazerr: 'blazer', blzer: 'blazer', blzaer: 'blazer', jaket: 'jacket', jackt: 'jacket', jakcet: 'jacket', jcket: 'jacket', jackett: 'jacket', hoddie: 'hoodie', hoody: 'hoodie', hodi: 'hoodie', hoooodie: 'hoodie', dres: 'dress', dresz: 'dress', cote: 'coat', snakers: 'sneakers', sneekers: 'sneakers', snekrs: 'sneakers', snekaers: 'sneakers', snickers: 'sneakers', trainrs: 'trainers', traners: 'trainers', trainerss: 'trainers', bots: 'boots', booots: 'boots', bootz: 'boots', heeels: 'heels', hels: 'heels', suade: 'suede', ankel: 'ankle', handbg: 'handbag', baag: 'bag', blt: 'belt', beltt: 'belt', neklace: 'necklace', necklce: 'necklace', sunglases: 'sunglasses', jewlery: 'jewellery', jewlry: 'jewellery', jewelery: 'jewellery', jewelry: 'jewellery', womans: 'womens', womenss: 'womens', menz: 'mens', menss: 'mens', blk: 'black', wht: 'white', whit: 'white', crm: 'cream', graay: 'grey', gery: 'grey', bege: 'beige', biege: 'beige', sliver: 'silver', glod: 'gold', longsleeve: 'long sleeve', cargoes: 'cargo', cargoe: 'cargo', oversided: 'oversized', tp: 'top', belted: 'belt' };
    const SYN2 = [['co ord set', 'coord'], ['co-ord set', 'coord'], ['matching set', 'coord'], ['two piece', 'coord'], ['co-ord', 'coord'], ['co ord', 'coord'], ['co ords', 'coord'], ['ankle boots', 'boot'], ['chelsea boots', 'boot'], ['heeled boots', 'boot'], ['knee high boots', 'boot'], ['black heels', 'black heel'], ['black boots', 'black boot'], ['leather boots', 'leather boot'], ['suede boots', 'suede boot'], ['white trainers', 'white trainer'], ['black trainers', 'black trainer'], ['running trainers', 'trainer'], ['dress shoes', 'loafer'], ['smart shoes', 'loafer'], ['crossbody bag', 'crossbody'], ['cross body bag', 'crossbody'], ['midi dress', 'midaxi dress'], ['black midi dress', 'black midaxi dress'], ['gym set', 'tracksuit'], ['office outfit', 'tailored'], ['gym outfit', 'tracksuit'], ['night out', 'tailored'], ['going out', 'tailored'], ['date night', 'tailored'], ['formal wear', 'tailored'], ['smart wear', 'tailored']];
    const SYN1 = { pants: 'trousers', trouser: 'trousers', jeans: 'denim', cargos: 'cargo', tee: 'tshirt', tees: 'tshirt', sweatpants: 'joggers', chinos: 'trousers', baggy: 'relaxed', loose: 'relaxed', skinny: 'slim', tight: 'contour', knitted: 'knit', knitwear: 'knit', sneakers: 'trainers', sneaker: 'trainer', handbag: 'bag', purse: 'bag', wallet: 'cardholder', pumps: 'flats', workwear: 'tailored' };
    const SUBTYPE_ALIASES = { boot: 'boot', boots: 'boot', ankle: 'boot', heel: 'heel', heels: 'heel', trainer: 'trainer', trainers: 'trainer', sneaker: 'trainer', sneakers: 'trainer', sandal: 'sandal', sandals: 'sandal', flat: 'flat', flats: 'flat', pump: 'pump', pumps: 'pump', loafer: 'loafer', loafers: 'loafer', mule: 'mule', slide: 'mule', crossbody: 'crossbody', tote: 'tote', handbag: 'handbag', backpack: 'backpack', purse: 'purse', clutch: 'clutch', shoulder: 'shoulder', bum: 'bum' };
    const FOOTWEAR_TERMS = new Set(['boot', 'boots', 'heel', 'heels', 'trainer', 'trainers', 'sneaker', 'sneakers', 'sandal', 'sandals', 'flat', 'flats', 'loafer', 'loafers', 'mule', 'mules', 'pump', 'pumps', 'slide', 'slides', 'shoe', 'shoes', 'nylon', 'runner', 'hardware']);
    const ACCESSORY_TERMS = new Set(['bag', 'belt', 'sunglasses', 'necklace', 'ring', 'earring', 'earrings', 'jewellery', 'hat', 'cap', 'cardholder', 'wallet', 'crossbody', 'tote', 'handbag', 'purse']);
    const COORD_TRIGGERS = new Set(['coord', 'matching', 'twopiece', 'piece', 'set']);
    const FASHION_DICT = ['blazer', 'trousers', 'jacket', 'coat', 'dress', 'skirt', 'top', 'shirt', 'hoodie', 'jumper', 'cardigan', 'denim', 'jeans', 'shorts', 'leggings', 'tracksuit', 'joggers', 'bodysuit', 'jumpsuit', 'waistcoat', 'blazers', 'jackets', 'coats', 'dresses', 'skirts', 'tops', 'shirts', 'hoodies', 'jumpers', 'cardigans', 'trainers', 'boots', 'heels', 'sneakers', 'sandals', 'flats', 'loafers', 'mules', 'pumps', 'shoes', 'bag', 'belt', 'sunglasses', 'necklace', 'jewellery', 'hat', 'cap', 'cardholder', 'wallet', 'crossbody', 'tote', 'handbag', 'backpack', 'black', 'white', 'cream', 'beige', 'brown', 'navy', 'grey', 'green', 'red', 'pink', 'gold', 'silver', 'leather', 'suede', 'knit', 'ribbed', 'satin', 'wool', 'twill', 'velvet', 'wide', 'slim', 'oversized', 'relaxed', 'fitted', 'cropped', 'tailored', 'cargo', 'midi', 'maxi', 'mini', 'ankle', 'platform', 'shoulder', 'clutch', 'turtleneck'];
    const FUZZY_SAFE = new Set(['tshirt', 't-shirt', 'tee', 'tees', 'leg', 'wide', 'size', 'good', 'tee', 'mens', 'womens', 'men', 'women', 'slim', 'large', 'medium', 'small', 'and', 'for', 'the', 'long', 'short', 'set', 'fit', 'top', 'run', 'knit', 'crop', 'lace', 'zip', 'raw', 'cap', 'random', 'pls', 'want', 'gift', 'maybe', 'very', 'really', 'cargo', 'midi', 'maxi', 'mini', 'ankle', 'relaxed', 'fitted', 'cropped', 'tailored', 'oversized', 'leather', 'suede', 'ribbed', 'satin', 'wool', 'twill', 'velvet', 'black', 'white', 'blue', 'red', 'grey', 'navy', 'pink', 'green', 'gold', 'silver', 'brown', 'beige', 'cream', 'platform', 'clutch', 'shoulder', 'backpack', 'tote', 'heel', 'boot', 'shoe', 'flat', 'mule', 'pump', 'slide', 'bag', 'belt', 'hat', 'ring', 'tie', 'bow', 'hem', 'cut', 'key', 'slim', 'high', 'low', 'big', 'old', 'new', 'wide']);
    function editDist(a, b) { const m = a.length, n = b.length; if (Math.abs(m - n) > 2) return 99; const d = Array.from({ length: m + 1 }, (_, i) => Array.from({ length: n + 1 }, (_, j) => i === 0 ? j : j === 0 ? i : 0)); for (let i = 1; i <= m; i++)for (let j = 1; j <= n; j++) { d[i][j] = a[i - 1] === b[j - 1] ? d[i - 1][j - 1] : 1 + Math.min(d[i - 1][j], d[i][j - 1], d[i - 1][j - 1]); if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1); } return d[m][n]; }
    function fuzzyCorrect(word) { if (word.length < 3 || FUZZY_SAFE.has(word) || FASHION_DICT.includes(word)) return word; let best = word, bestDist = 99; const threshold = word.length >= 6 ? 2 : 1; for (const c of FASHION_DICT) { if (FUZZY_SAFE.has(c)) continue; if (Math.abs(c.length - word.length) > 2) continue; const d = editDist(word, c); if (d <= threshold && d < bestDist || (d === bestDist && d <= threshold && c.length > best.length)) { bestDist = d; best = c; } } return bestDist <= threshold ? best : word; }
    const S = { q: '', tab: '', page: 1, submitted: false };
     const PAGE_SIZE = window.location.pathname.includes('/search')
    ? 48
    : 6;
    function parseQuery(raw) {
      if (!raw || !raw.trim()) return { terms: [], preferredTypes: [], subtypeTerms: [], orMode: false, genderFilter: null, coordMode: false, footwearMode: false, accessoryMode: false, isSKU: false };
      const trimmed = raw.trim();
      // Detect SKU prefix at start of query (handles 'WMN4223 black', 'WMN4223 size 8' etc)
      const _skuPrefixM = /^([A-Z]{2,4}[\d]{3,6}(?:[.\-][\w./]+)*)(?=\s|$)/i.exec(trimmed);
      const _skuCandidate = _skuPrefixM ? _skuPrefixM[1] : null;
      const _isSKU = _skuCandidate && /\d{3,}/.test(_skuCandidate) && _skuCandidate.length >= 5;
      if (_isSKU) return { terms: [], preferredTypes: [], subtypeTerms: [], orMode: false, genderFilter: null, coordMode: false, footwearMode: false, accessoryMode: false, isSKU: true, skuQuery: _skuCandidate, skuRest: trimmed.slice(_skuCandidate.length).trim() };
      // Treat standalone numeric tokens as size queries
      let _trimmedMod = trimmed;
      if (/^\d{1,2}$/.test(trimmed.trim()) && parseInt(trimmed.trim()) >= 4 && parseInt(trimmed.trim()) <= 22)
        _trimmedMod = 'size ' + trimmed.trim();
      let q = _trimmedMod.toLowerCase(); const orMode = /\bor\b/.test(q); let gf = null;
      for (const [tok, gender] of Object.entries(GENDER_TOKENS)) { const re = new RegExp('\\b' + tok.replace(/'/g, "'?") + '\\b', 'gi'); if (re.test(q)) { gf = gender; q = q.replace(re, '').trim(); break; } }
      for (const [tok2] of Object.entries(GENDER_TOKENS)) { q = q.replace(new RegExp('\\b' + tok2.replace(/'/g, "'?") + '\\b', 'gi'), '').trim(); }
      for (const [phrase, rep] of SYN2) if (q.includes(phrase)) q = q.replace(phrase, rep);
      for (const [t, f] of Object.entries(TYPOS)) q = q.replace(new RegExp('\\b' + t + '\\b', 'g'), f);
      // Normalise hyphenated tshirt forms before tokenising
      q = q.replace(/\bt-shirts?\b/gi, 'tshirt').replace(/\btshirts\b/gi, 'tshirt');
      q = q.split(/\s+/).map(tok => { if (tok.length < 3 || FUZZY_SAFE.has(tok) || FASHION_DICT.includes(tok)) return tok; return fuzzyCorrect(tok); }).join(' ');
      let tokens = q.split(/\s+/).filter(t => t.length > 1);
      // Capture subtype terms BEFORE SYN1 expands them (e.g. purse→bag loses subtype)
      const _preSYN1Subtypes = [...new Set(tokens.filter(t => SUBTYPE_ALIASES[t]).map(t => SUBTYPE_ALIASES[t]))];
      tokens = tokens.flatMap(t => { if (SYN1[t] !== undefined) { const r = SYN1[t]; return r ? r.includes(' ') ? r.split(' ') : [r] : []; } return [t]; });
      const hard = [...new Set(tokens.filter(t => !STOP.has(t) && !INTENT.has(t) && t.length > 1))];
      const all = [...new Set(tokens.filter(t => !STOP.has(t) && t.length > 1))];
      const stypes = [...new Set([..._preSYN1Subtypes, ...all.filter(t => SUBTYPE_ALIASES[t]).map(t => SUBTYPE_ALIASES[t])])];
      const coordMode = hard.some(t => COORD_TRIGGERS.has(t));
      const fwMode = hard.some(t => FOOTWEAR_TERMS.has(t)) || stypes.length > 0;
      const accMode = hard.some(t => ACCESSORY_TERMS.has(t));
      const preferred = []; for (const t of hard) if (TYPE_ALIASES[t]) preferred.push(...TYPE_ALIASES[t]);
      if (fwMode) preferred.push('Footwear');
      const { cleaned: _qc, sizes: _qs } = extractSizes(q); const _qsFinal = _qs.length ? _qs : []; return { terms: hard, preferredTypes: [...new Set(preferred)], subtypeTerms: stypes, orMode, genderFilter: gf, coordMode, footwearMode: fwMode, accessoryMode: accMode, isSKU: false, querySizes: _qsFinal };
    }
    function scoreProduct(p, terms, preferred, stypes, orMode, coordMode, fwMode, accMode) {
      const hay = (p._search || (p.title + ' ' + p.type + ' ' + (p.vendor || '') + ' ' + (p.colour || ''))).toLowerCase().replace(/-/g, ' ');
      const titleL = p.title.toLowerCase(); const subs = p.subtypes || [];
      // If product type matches preferred, count it as a text match (category query)
      const typeMatch = preferred.length > 0 && preferred.includes(p.type) ? 1 : 0;
      let matched = typeMatch; for (const t of terms) if (hay.includes(t)) matched++;
      const total = terms.length; if (total === 0) return { pass: true, score: 0 };
      const stHit = stypes.some(s => subs.includes(s));
      const effM = stHit ? Math.max(matched, total) : matched;
      if (coordMode && total === 1 && terms[0] === 'coord') return { pass: !!p.coord, score: p.coord ? 50 : 0 };
      const hardAnd = total <= 3;
      if (hardAnd && !orMode && effM < total) return { pass: false, score: 0 };
      if (!hardAnd && !orMode && effM / total < 0.5) return { pass: false, score: 0 };
      if (orMode && effM === 0) return { pass: false, score: 0 };
      let s = effM * 10;
      if (preferred.length) { if (preferred.includes(p.type)) s += 50; else s -= 15; }
      if (stypes.length) s += stypes.filter(st => subs.includes(st)).length * 35;
      if (terms.some(t => titleL.includes(t))) s += 5;
      if (fwMode) { if (FOOTWEAR_TYPES.has(p.type) || isFootwearProduct(p)) s += 30; else if (APPAREL.has(p.type)) s -= 25; }
      else if (accMode) { if (ACCESSORY_TYPES.has(p.type)) s += 20; else if (APPAREL.has(p.type)) s -= 10; }
      else { if (APPAREL.has(p.type)) s += 15; else if (ACCESSORY_TYPES.has(p.type) || FOOTWEAR_TYPES.has(p.type)) s -= 20; }
      const cols = p.colours && p.colours.length ? p.colours : (p.colour ? [p.colour] : []);
      if (cols.some(c => terms.includes(c.toLowerCase()))) s += 8;
      if (coordMode && p.coord) s += 40;
      return { pass: true, score: s };
    }

    // 'unisex' query: only products with 'unisex' in title
    function isUnisexTitle(p) { return p.title.toLowerCase().includes('unisex'); }
    // Footwear detection: inferred type OR title matches common footwear phrases (ME catalogue)
    const FOOTWEAR_TITLE_RE = /\b(nylon\s+runner|boots?|trainers?|sneakers?|sandal|sandals|mule|mules|slide|slides|loafer|loafers|heel|heels|pump|pumps|shoe|shoes|flats?\s+with\s+hardware|flats?)\b/i;
    function isFootwearProduct(p) {
      if (p.type === 'Footwear') return true;
      return FOOTWEAR_TITLE_RE.test(String(p.title || ''));
    }
    function blobMatchesAllTerms(blob, terms) {
      const b = String(blob || '').toLowerCase();
      return terms.every(t => {
        if (!t || t.length < 2) return true;
        try {
          return new RegExp('\\b' + t.replace(/[.*+?^${}()|[\\]\\\\]/g, '\\\\$&') + '\\b', 'i').test(b);
        } catch (e) {
          return b.includes(t);
        }
      });
    }
    // Tab helpers — Woman/Man buckets are vendor-driven; Accessories also vendor-driven (matches /collections/mens-accessories & womens-accessories taxonomy)
    function vendorStr(p) { return String(p.vendor || ''); }
    function isAccessoryProduct(p) {
      const s = vendorStr(p).toLowerCase().trim();
      if (!s) return false;
      if (/\baccessories\b/.test(s)) return true;
      const t = String(p.title || '').toLowerCase();
      if (/\bbasketball\b/i.test(s) || /\bbasketball\b/i.test(t)) return true;
      if (/\blifestyle\b/i.test(s)) return true;
      return /\b(bags?|tote|headwear|hats?|belts?|gloves?|mittens?|scarfs?|scarves|sunglasses|ties?|cufflinks?|jewellery|jewelry|necklaces?|earrings?|rings?|underwear|boxers?)\b/i.test(s);
    }
    function applyTab(res, tab) {
      if (!tab) return res;
      if (tab === 'Accessories') return res.filter(isAccessoryProduct);
      if (tab === 'Woman') return res.filter(p => {
        if (isAccessoryProduct(p)) return false;
        return /woman/i.test(vendorStr(p));
      });
      if (tab === 'Man') return res.filter(p => {
        if (isAccessoryProduct(p)) return false;
        const v = vendorStr(p);
        if (/woman/i.test(v)) return false;
        return /\bman\b/i.test(v);
      });
      return res;
    }
    // Collection search — title/handle matches query, optionally filtered by tab
    // Handles in this list → ONLY appear in Accessories tab (even if title contains men/women)
    const ACCESSORIES_HANDLES = ['accessories', 'bags', 'headwear', 'gloves-mittens', 'ties-cufflinks', 'scarfs', 'scarf', 'sunglasses', 'belts', 'jewellery', 'lifestyle', 'hats', 'gloves', 'footwear'];
    function isAccessoriesOnlyCollection(c) {
      const h = String(c.handle || '').toLowerCase();
      for (const kw of ACCESSORIES_HANDLES) {
        if (h === kw) return true;
        if (h.endsWith('-' + kw)) return true;
      }
      return false;
    }
    function collectionMatchesTab(c, tab) {
      if (!tab) return true;
      const accOnly = isAccessoriesOnlyCollection(c);
      // Accessories tab: only the strict handle-keyword collections
      if (tab === 'Accessories') return accOnly;
      // For Man/Woman, exclude accessories-only collections (even if title has men/women)
      if (accOnly) return false;
      const tl = String(c.title || '').toLowerCase();
      if (tab === 'Woman') return /\bwom[ea]n|ladies/i.test(tl);
      if (tab === 'Man') {
        if (/\bwom[ea]n/i.test(tl)) return false;
        return /\bm[ea]ns?\b/i.test(tl);
      }
      return true;
    }
    function searchCollections(q, tab) {
      if (!q || !String(q).trim()) return [];
      if (!Array.isArray(ALL_COLLECTIONS) || !ALL_COLLECTIONS.length) return [];
      const ql = String(q).toLowerCase().trim();
      const escQ = ql.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      // Word-boundary-start match: avoids "men" matching "women", but "top" still matches "tops"
      const re = new RegExp('\\b' + escQ, 'i');
      const out = [];
      for (const c of ALL_COLLECTIONS) {
        const tl = String(c.title || '');
        const hl = String(c.handle || '').replace(/-/g, ' ');
        if (!re.test(tl) && !re.test(hl)) continue;
        if (!collectionMatchesTab(c, tab)) continue;
        out.push(c);
      }
      return out;
    }
    function extractSizes(q) {
      const sizes = []; let c = (q || '');
      c = c.replace(/\bsize\s+uk\s*(\d+)\b/gi, function (m, n) { sizes.push('UK ' + n); return ''; });
      c = c.replace(/\bsize\s+(\d+)\b/gi, function (m, n) { const ni = parseInt(n); if (ni >= 3 && ni <= 16) sizes.push('UK ' + n); else if (ni >= 6 && ni <= 22) sizes.push(n); return ''; });
      c = c.replace(/\buk\s*(\d+)\b/gi, function (m, n) { sizes.push('UK ' + n); return ''; });
      c = c.replace(/\bw(\d{2})\b/gi, function (m, n) { sizes.push('W' + n); return ''; });
      const _am = { xs: 'XS', s: 'S', m: 'M', l: 'L', xl: 'XL', xxl: 'XXL', small: 'S', medium: 'M', large: 'L', xsmall: 'XS', xlarge: 'XL' };
      for (const [word, norm] of Object.entries(_am)) {
        const re2 = new RegExp('\\b' + word + '\\b', 'gi');
        if (re2.test(c)) { sizes.push(norm); c = c.replace(re2, ''); }
      }
      return { cleaned: c.replace(/\s+/g, ' ').trim(), sizes: [...new Set(sizes)] };
    }
    function filtered() {
      // Empty state only when data isn't ready (or empty dataset)
      if (!__MDV_DATA_READY || !Array.isArray(ALL) || ALL.length === 0) return null;
      // Default view: show all products when no search submitted and no tab active
      if (!S.submitted && !S.tab) {
        return [...ALL].sort((a, b) => (b._rank || 0) - (a._rank || 0) || a.title.localeCompare(b.title));
      }
      let res = ALL;
      res = applyTab(res, S.tab);
      if (!S.q) {
        // Sort by commercial rank when browsing without a query
        return [...res].sort((a, b) => (b._rank || 0) - (a._rank || 0) || a.title.localeCompare(b.title));
      }
      const parsed = parseQuery(S.q);
      if (parsed.isSKU) {
        let _skuRes = skuSearch(parsed.skuQuery);
        _skuRes = applyTab(_skuRes, S.tab);
        // Use skuRest (everything after the SKU) for constraints
        const _rest = parsed.skuRest || '';
        if (_rest) {
          // Size constraint
          const _sz = extractSizes(_rest).sizes;
          if (_sz.length > 0) _skuRes = _skuRes.filter(p => (p.sizes || []).some(s => _sz.includes(s)));
          // Colour constraint
          const _COLS = new Set(['black', 'white', 'cream', 'beige', 'grey', 'brown', 'navy',
            'blue', 'green', 'red', 'pink', 'gold', 'silver', 'olive', 'indigo', 'taupe', 'dark olive',
            'wine red', 'midnight', 'charcoal', 'burgundy', 'espresso', 'off white']);
          const _ct = _rest.toLowerCase().split(/\s+/).filter(t => _COLS.has(t));
          if (_ct.length > 0) _skuRes = _skuRes.filter(p => _ct.some(c => (p.colour || '').toLowerCase().includes(c)));
        }
        return _skuRes;
      }
      const { terms, preferredTypes, subtypeTerms, orMode, genderFilter, coordMode, footwearMode, accessoryMode } = parsed;
      const _CWORDS = new Set(['black', 'white', 'cream', 'beige', 'grey', 'brown', 'navy',
        'blue', 'green', 'red', 'pink', 'gold', 'silver', 'olive', 'indigo', 'taupe']);
      const colourTokens = terms.filter(t => _CWORDS.has(t));
      if (genderFilter && !S.tab && genderFilter !== 'Unisex') res = res.filter(p => p.gender === genderFilter || isUnisexTitle(p));
      const _isUnisexQ = terms.includes('unisex');
      if (_isUnisexQ) { res = res.filter(p => isUnisexTitle(p)); const ui = terms.indexOf('unisex'); if (ui > -1) terms.splice(ui, 1); }
      if (terms.length > 0 || subtypeTerms.length > 0) {
        // Hard pre-filter by category
        if (preferredTypes.length > 0 && !coordMode) {
          if (_isUnisexQ) {
            // For unisex queries: match by type OR by token in title (catches jacket-hoodies)
            res = res.filter(p => preferredTypes.includes(p.type) || terms.some(t => p.title.toLowerCase().includes(t)));
          } else {
            // Match canonical type OR full-text blob (title + vendor + description + collections + tags) for ME store data
            res = res.filter(p => {
              if (preferredTypes.includes(p.type)) return true;
              if (!terms.length) return false;
              return blobMatchesAllTerms(p._search, terms);
            });
          }
        }
        // Hard colour filter when explicit colour in query
        const _COLOUR_WORDS = new Set(['black', 'white', 'cream', 'beige', 'grey', 'brown',
          'navy', 'blue', 'green', 'red', 'pink', 'gold', 'silver', 'olive', 'indigo', 'taupe']);
        const _qColours = terms.filter(t => _COLOUR_WORDS.has(t));
        if (_qColours.length > 0) {
          const _colGroup = t => t === 'grey' ? 'Grey' : t === 'navy' ? 'Navy' : t.charAt(0).toUpperCase() + t.slice(1);
          const _colGroups = _qColours.map(_colGroup);
          res = res.filter(p => _colGroups.some(cg => p.colour_group === cg || (p.colour || '').toLowerCase().includes(_qColours[0])));
        }
        const scored = [];
        for (const p of res) { const { pass, score } = scoreProduct(p, terms, preferredTypes, subtypeTerms, orMode, coordMode, footwearMode, accessoryMode); if (pass) scored.push({ p, score }); }
        // Broad query: use commercial rank as tiebreaker
        const _isBroad = terms.length <= 2 && colourTokens.length === 0;
        if (_isBroad) {
          scored.sort((a, b) => b.score - a.score || (b.p._rank || 0) - (a.p._rank || 0) || a.p.title.localeCompare(b.p.title));
        } else {
          scored.sort((a, b) => b.score - a.score || a.p.title.localeCompare(b.p.title));
        }
        res = scored.map(x => x.p);
      }
      return res;
    }

    function renderAutocomplete(q) {
      const list = document.getElementById('ac-list');
      if (list) {
        list.style.display = 'none';
        list.innerHTML = '';
      }
      const ghost = window.__ghostEl;
      if (!q || q.length < 2) {
        if (ghost) ghost.textContent = '';
        return;
      }

      const ql = q.toLowerCase().trim();
      const match = SUGGESTIONS.find(([s]) =>
        s.toLowerCase().startsWith(ql)
      );
      if (match) {
        window.__mdvFirstSuggestion = match[0];
        if (ghost) {
          ghost.textContent = match[0];
        }
      } else {
        window.__mdvFirstSuggestion = '';
        if (ghost) {
          ghost.textContent = '';
        }
      }
    }
    function getFirstSuggestion() {
      return window.__mdvFirstSuggestion || '';
    }


    function showAC(items) {
      const list = document.getElementById('ac-list');
      if (!items.length) { list.style.display = 'none'; return; }
      list.innerHTML = '';
      items.forEach(function (item) {
        const div = document.createElement('div');
        div.className = 'ac-item';
        div.innerHTML = '<span class="ac-label">' + esc(item.label) + '</span>' + (item.hint ? '<span class="ac-hint">' + esc(item.hint) + '</span>' : '');
        div.addEventListener('mousedown', function (e) {
          e.preventDefault();
          selectAC(item.label);
        });
        list.appendChild(div);
      });
      list.style.display = 'block';
    }

    function selectAC(label) {
      const inp = document.getElementById('q');
      inp.value = label; S.q = label; S.submitted = true;
      document.getElementById('ac-list').style.display = 'none';
      go();
    }

    function renderCollections() {
      const el = document.getElementById('collections');
      const elcolltion = document.querySelector('.search-collection-main');
      if (!el) return;
      if (!__MDV_DATA_READY || !S.q || !S.q.trim()) {
        el.innerHTML = '';
        elcolltion.style.display = "none";
        return;
      }
      const matches = searchCollections(S.q, S.tab);
      if (!matches.length) {
        elcolltion.style.display = "none";
        // el.innerHTML = `<div class="search-page-error" style="padding: 0;"><p>Sorry, Nothing Found For Collection "${S.q}"</p></div>`;
        el.innerHTML = '';

        return;
      }
      const links = matches.slice(0, 8).map(c => {
        return `<a href="/collections/${esc(c.handle)}" class="search-collection-link">${esc(c.title)}</a>`;
      }).join('');
      el.innerHTML = `<h2 class="search-collections-title">Collections</h2>${links}`;
      elcolltion.style.display = "block";

    }
    function render() {
      renderCollections();
      let items = filtered();
      if (items === null) {
        document.getElementById('rc').textContent = '';
        document.getElementById('pag').innerHTML = '';
        document.getElementById('grid').innerHTML = '<div style="grid-column:1/-1"></div>';
        const _tt = document.querySelector('.search-page-title');
        if (_tt) _tt.innerHTML = '<h2>Products</h2>';
        return;
      }
      const total = items.length;
      const pages = Math.max(1, Math.ceil(total / PAGE_SIZE));

      if (S.page > pages) S.page = 1;

      const visibleCount = Math.min(S.page * PAGE_SIZE, total);
      const slice = items.slice(0, visibleCount);
      document.getElementById('rc').textContent = total ? total.toLocaleString() + ' results' : '';
      const grid = document.getElementById('grid');
      function renderPriceHtml(p) {
        const priceRaw = String(p.price_raw || '').trim();
        const compareRaw = String(p.compare_at_raw || '').trim();
        const price = Number(p.price);
        const compare = Number(p.compare_at);
        const onSale = Number.isFinite(price) && Number.isFinite(compare) && (price < compare);

        const shopCur = String(p.currency_code || '').trim() || ((typeof window !== 'undefined' && typeof window.shopCurrency !== 'undefined' && window.shopCurrency) ? String(window.shopCurrency) : '');
        
       const currencyFormats = {
          GBP: "£{{amount_no_decimals}}", ALL: "Lek {{amount}} ALL", EUR: "€{{amount_with_comma_separator}}",
          DKK: "{{amount_with_comma_separator}} DKK", ISK: "{{amount_no_decimals_with_comma_separator}} ISK", LAK: "₭{{amount}} LAK",
          CHF: "CHF {{amount}}", MKD: "ден {{amount}} MKD", ILS: "{{amount}} NIS", RSD: "{{amount}} RSD", CAD: "{{amount_no_decimals}} CAD",
          USD: "${{amount_no_decimals}}", AUD: "${{amount_no_decimals}} AUD", SAR: "{{amount_no_decimals}} SAR", AED: "{{amount_no_decimals}} AED",
          QAR: "QAR {{amount_no_decimals}}", SGD: "${{amount}} SGD", JPY: "¥{{amount_no_decimals}} JPY", INR: "Rs. {{amount}}",
          NZD: "${{amount}} NZD", PHP: "₱{{amount}} PHP", HKD: "HK${{amount}}", MYR: "RM{{amount}} MYR", AMD: "{{amount}} AMD",
          DOP: "RD$ {{amount}}", AZN: "m.{{amount}} AZN", TWD: "${{amount}} TWD", THB: "{{amount}} ฿ THB", KZT: "₸{{amount}} KZT",
          KRW: "₩{{amount_no_decimals}} KRW", IDR: "Rp {{amount_with_comma_separator}} IDR", MAD: "Dh {{amount}} MAD", NGN: "₦{{amount}} NGN",
          MDL: "{{amount}} MDL", EGP: "LE {{amount}} EGP", LBP: "L£{{amount}} LBP", BAM: "KM {{amount_with_comma_separator}} BAM",
          CNY: "¥{{amount}} CNY", VND: "{{amount_no_decimals_with_comma_separator}} VND", LKR: "Rs {{amount}} LKR", PEN: "S/. {{amount}} PEN",
          DZD: "DA {{amount}} DZD", PKR: "Rs.{{amount}} PKR", KHR: "KHR{{amount}}", MVR: "Rf{{amount}} MRf", KES: "KSh{{amount}}",
          PYG: "Gs. {{amount_no_decimals_with_comma_separator}} PYG", BOB: "Bs{{amount_with_comma_separator}} BOB", BND: "${{amount}} BND", BDT: "Tk {{amount}} BDT", NPR: "Rs{{amount}} NPR"
        };

        const formatMoney = (v) => {
          const num = parseFloat(String(v || '').trim().replace(',', '.'));
          if (!Number.isFinite(num)) return '';
          
          let template = '{{amount}}';
          if (shopCur && currencyFormats[shopCur]) {
            template = currencyFormats[shopCur];
          } else if (typeof document !== 'undefined' && document.body) {
            const bodyFormat = document.body.getAttribute('data-shop-moneyformat');
            if (bodyFormat) template = bodyFormat;
          }

          let value = '';
          const match = template.match(/\{\{\s*(\w+)\s*\}\}/);
          const type = match ? match[1] : 'amount';

          const parts = num.toFixed(2).split('.');
          let dollars = parts[0];
          let cents = parts[1];

          if (type === 'amount_no_decimals') {
            dollars = dollars.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            value = dollars;
          } else if (type === 'amount_with_comma_separator') {
            dollars = dollars.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
            value = dollars + ',' + cents;
          } else if (type === 'amount_no_decimals_with_comma_separator') {
            dollars = Math.round(num).toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
            value = dollars;
          } else {
            // Default {{amount}} and others
            dollars = dollars.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
            value = dollars + '.' + cents;
          }

          return template.replace(/\{\{\s*\w+\s*\}\}/, value);
        };

        const priceVal = priceRaw || (Number.isFinite(price) ? String(price) : '');
        const compareVal = compareRaw || (Number.isFinite(compare) ? String(compare) : '');
        
        const priceTxt = priceVal ? formatMoney(priceVal) : '';
        const compareTxt = (onSale && compareVal) ? formatMoney(compareVal) : '';
        
        const priceHtml = priceTxt ? (shopCur && !priceTxt.includes(shopCur) && !currencyFormats[shopCur] ? (priceTxt + ' ' + shopCur) : priceTxt) : '';
        const compareHtml = compareTxt ? (shopCur && !compareTxt.includes(shopCur) && !currencyFormats[shopCur] ? (compareTxt + ' ' + shopCur) : compareTxt) : '';

        // discount_badge:true behaviour
        let badge = '';
        if (onSale) {
          // Liquid: salePercent = (compare_at_price_max - price) / compare_at_price_max * 100
          let salePercent = ((compare - price) * 100.0) / compare;
          if (!Number.isFinite(salePercent)) salePercent = 0;
          // modulo 5 rounding rule
          const checkMultipleOfFive = Math.round(salePercent % 5);
          let newSalePercent = (checkMultipleOfFive > 0) ? (Math.round((salePercent / 5.0)) * 5) : Math.round(salePercent);
          if (newSalePercent > 40 && newSalePercent < 50) newSalePercent = 50;
          newSalePercent = Math.round(newSalePercent);
          badge = `<span style="display: inline-block;" class="label_onsale">${esc(String(newSalePercent))}% Off</span>`;
        }

        return `<p class="product_price_wrap ${onSale ? 'onsale' : ''}">
      <span class="actual-price1 ${onSale ? 'onsale' : ''}"><span class="money">${priceHtml}</span></span>
      ${onSale ? `<span class="compare-price"><span class="money">${compareHtml}</span></span>` : ''}
      ${badge}
    </p>`;
      }
      function renderProductTitleParts(title) {
        const parts = String(title || '').split(' - ').map(s => s.trim()).filter(Boolean);
        if (parts.length < 2) {
          return `<div class="main-product-title"><a href="#" class="main-product-inner color-square-item-href"><h5 class="text-unset">${esc(title)}</h5></a></div>`;
        }
        const first_part = parts[0];
        const last_part = parts[parts.length - 1];
        const middle_part = parts.slice(1, -1).join(' - ');
        if (!middle_part) {
          return `<div class="main-product-title"><a href="#" class="main-product-inner color-square-item-href"><h5 class="text-unset">${esc(title)}</h5></a></div>`;
        }
        return `
      <div class="main-product-title new-collection-product-title">
        <div class="product-card-redesign">
          <h5><span class="text-unset">${esc(first_part)}</span></h5>
          <div class="product-hover"></div>
        </div>
        <a href="#" class="main-product-inner color-square-item-href"><h5 class="text-unset">${esc(middle_part)} in ${esc(last_part)}</h5></a>
      </div>
    `;
      }
      function buildVariantUrl(handle, variantId) {
        if (!handle) return '#';
        if (!variantId) return '/products/' + encodeURIComponent(handle);
        return '/products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(variantId);
      }
      function renderSizeBox(p) {
        const vars = Array.isArray(p._variants) ? p._variants : [];
        if (!vars.length) return '';
        // Find a primary option key: size OR denominations
        const hasSize = vars.some(v => v && v.opts && v.opts.size);
        const hasDen = vars.some(v => v && v.opts && v.opts.denominations);
        const key = hasSize ? 'size' : (hasDen ? 'denominations' : '');
        if (!key) return '';
        const items = vars.map(v => {
          const raw = v && v.opts ? v.opts[key] : '';
          if (!raw) return null;
          let label = String(raw);
          if (key === 'size') label = label.replace(/^UK\s+/i, '');
          if (key === 'denominations') label = label.replace(/\.00$/, '');
          const href = buildVariantUrl(p.handle, v.id);
          const cls = v.available ? '' : ' class="size-sold"';
          return `<li${cls}><a href="${href}">${esc(label)}</a></li>`;
        }).filter(Boolean);
        if (!items.length) return '';
        return `<div class="product-size-box"><ul>${items.join('')}</ul></div>`;
      }
      function renderColourSquarePlaceholder(p, idx) {
        const titleParts = String(p.title || '').replace(/&/g, '').split(' - ').map(s => s.trim()).filter(Boolean);
        const sku0 = (p.skus && p.skus.length ? p.skus[0] : '');
        const skuParts = String(sku0 || '').split('-').filter(Boolean);
        const baseSku = skuParts[0] || '';
        const genderVal = String(p.gender || p.vendor || '').trim().replace(/ /g, '+').replace(/&/g, '%26');
        const randomNumber = (idx == null) ? Math.floor(Math.random() * 1000000) : idx;
        const handleRand = String(p.handle || '') + '-' + String(randomNumber);
        const titleAttr = (titleParts[2] ? `data-title="${esc(titleParts[0] || '')}"` : `data-sku="${esc(baseSku)}"`);
        return `
      <div class="main_colors_wrapper" data-handle="${esc(handleRand)}" ${titleAttr} data-gender="${esc(genderVal)}" check-current="${esc(p.handle || '')}">
        <div class="product-alt-colours"></div>
      </div>
    `;
      }
      function renderProductTags(p) {
        const tags = Array.isArray(p.tags) ? p.tags : [];
        const collectionTitles = Array.isArray(p.collectionTitles) ? p.collectionTitles : [];
        const available = !!p.available;

        let html = '';
        let showTagCount = 1;
        const maxTagShow = 3;

        const hasTag = (tag) => {
          return tags.some(t => String(t).toLowerCase() === String(tag).toLowerCase());
        };

        const collectionHas = (txt) => {
          return collectionTitles.some(c => String(c).toLowerCase().includes(String(txt).toLowerCase()));
        };

        const addTag = (label, cls = '') => {
          if (showTagCount > maxTagShow) return;

          html += `<li${cls ? ` class="${cls}"` : ''}>${esc(label)}</li>`;
          showTagCount++;
        };

        const showNewIn =
          collectionHas('New In') &&
          !hasTag('bis-hidden');

        const coreCollection =
          collectionHas('Core Collection');

        const comingSoon =
          collectionHas('Coming Soon');

        // Coming Soon
        if (
          showTagCount <= maxTagShow &&
          !available &&
          (comingSoon || hasTag('comingsoon'))
        ) {
          addTag('Coming Soon');
        }

        // Notify Me
        if (
          showTagCount <= maxTagShow &&
          !available &&
          !comingSoon
        ) {
          if (
            !hasTag('comingsoon') &&
            !hasTag('bis-hidden') &&
            !hasTag('BIS-HIDDEN-TAG') &&
            !hasTag('BIS-HIDDEN') &&
            !hasTag('bis_hidden')
          ) {
            addTag('Notify Me When Available');
          }
        }

        // Core Collection
        if (
          showTagCount <= maxTagShow &&
          (hasTag('corecollection') || coreCollection)
        ) {
          addTag('Core Collection');
        }

        // Pre-Order
        if (
          showTagCount <= maxTagShow &&
          hasTag('Pre-Order')
        ) {
          addTag('Pre-Order');
        }

        // Limited Edition
        if (
          showTagCount <= maxTagShow &&
          hasTag('limitededition')
        ) {
          addTag('Limited Edition');
        }

        // Unisex
        if (
          showTagCount <= maxTagShow &&
          hasTag('unisex')
        ) {
          addTag('Unisex');
        }

        // Enhanced Fit & Fabric
        if (
          showTagCount <= maxTagShow &&
          hasTag('Enhanced Fit & Fabric')
        ) {
          addTag('Enhanced Fit & Fabric');
        }

        // Part of a Set
        if (
          showTagCount <= maxTagShow &&
          hasTag('partofaset')
        ) {
          addTag('Part of a Set');
        }

        // New In
        if (
          showTagCount <= maxTagShow &&
          showNewIn
        ) {
          addTag('New In');
        }

        // Online Exclusive
        if (
          showTagCount <= maxTagShow &&
          hasTag('onlineexclusive')
        ) {
          addTag('Online Exclusive');
        }

        // In-Store Exclusive
        if (
          showTagCount <= maxTagShow &&
          (
            hasTag('in-store-exclusive') ||
            hasTag('in-store exclusive')
          )
        ) {
          addTag('In-Store Exclusive');
        }

        if (!html) return '';

        return `
          <ul class="collection-product-tag">
            ${html}
          </ul>
        `;
      }
      function cardHtml(p, idx) {
        const href = p.handle ? ('/products/' + encodeURIComponent(p.handle)) : '#';
        const img1 = p.image ? `<img src="${esc(p.image)}" alt="${esc(p.title)}" loading="lazy" onerror="this.parentNode.innerHTML='<div class=noimg>MDV</div>'">` : `<div class="noimg">MDV</div>`;
        const img2 = p.image2 ? `<img src="${esc(p.image2)}" alt="${esc(p.title)}" class="hover-img" loading="lazy" onerror="this.src='${esc(p.image || '')}'">` : img1;
        let titleHtml = renderProductTitleParts(p.title || '').replaceAll('href="#"', `href="${href}"`);

        // Inject color-square placeholder HTML inside the .product-hover container
        const _ph = renderColourSquarePlaceholder(p, idx);

        const titleParts = String(p.title || '')
          .replace(/&/g, '')
          .split(' - ')
          .map(s => s.trim())
          .filter(Boolean);

        const isTitleRule = titleParts.length >= 3;

        if (isTitleRule) {

          titleHtml = titleHtml.replace(
            '<div class="product-hover"></div>',
            `<div class="product-hover">${_ph}</div>`
          );

        } else {

          titleHtml = titleHtml.replace(
            '</div>',
            `</div>${_ph}`
          );

        }
        const sizeBox = renderSizeBox(p);
        const priceHtml = renderPriceHtml(p);
        const tagsHtml = renderProductTags(p);

        // NEW: check first part has 2 letters + 3 numbers
        const first_part = String(p.title || '').split(' - ')[0]?.trim() || '';
        const isCodeName = /^[A-Za-z]{2}\d{3}/.test(first_part);

        return `
          <div class="main-product-item color-square-item ${isCodeName ? 'codename-design' : ''}" data-handle="${esc(p.handle || '')}">
            <div class="main-product-wrp">
              <div class="sizing-deta">
                <a href="${href}" class="main-product-inner color-square-item-href">
                  <div class="main-product-image color-square-item-image-main">
                    <div class="swiper main-product-carousel">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide">
                          <div class="swiper-slide-content">
                            ${img1}
                          </div>
                        </div>
                        <div class="swiper-slide">
                          <div class="swiper-slide-content">
                            ${img2}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </a>

                ${sizeBox}
              </div>

              <div class="main-product-content">
                ${tagsHtml}
                <div class="main-product-title-row">
                  ${titleHtml}
                </div>

                <div class="main-product-price">
                  ${priceHtml}
                </div>
              </div>
            </div>
          </div>
        `;
      }
      const titleEl = document.querySelector('.search-page-title');
      if (!slice.length) {
        grid.innerHTML = '';
        if (titleEl) titleEl.innerHTML = `<p class="search-product-error">Sorry, Nothing Found For "${esc(S.q || '')}"</p>`;
      } else {
        grid.innerHTML = slice.map((p, i) => cardHtml(p, i)).join('');
        if (titleEl) titleEl.innerHTML = '<h2>Products</h2>';
      }
      renderPag(pages);
      // Theme integration hook: swatch UI is initialized globally in Shopify theme.
      // Call after every render/update (search/pagination). 
      try {
        if (typeof window !== 'undefined' && typeof window.loadSwatches === 'function') {
          // Defer so DOM is committed before swatch script queries elements
          requestAnimationFrame(() => { try { window.loadSwatches(); } catch (_) { } });
        }
      } catch (_) { }

        // if(typeof cookieCurrency !== 'undefined' && cookieCurrency){
        //   Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
        // }
    }
    function renderPag(pages) {
      const el = document.getElementById('pag');
      if (!el) return;

      const total = filtered() ? filtered().length : 0;
      const visibleCount = Math.min(S.page * PAGE_SIZE, total);

      if (pages <= 1 || visibleCount >= total) {
        el.innerHTML = '';
        return;
      }

      el.innerHTML = `
        <button class="view-more-cta" onclick="goPage(${S.page + 1})">
          View More <span>|</span> ${visibleCount} of ${total}
        </button>
      `;
    }
    function setQ(q) { const inp = document.getElementById('q'); inp.value = q; S.q = q; S.submitted = true; go(); }
    function go() { S.page = 1; render(); }
    function goPage(n) {
      const pag = document.getElementById('pag');

      if (pag) {
        pag.innerHTML = `
          <div class="view-more-loader">
            <img 
              src="https://cdn.shopify.com/s/files/1/0282/6678/files/navigation_animation-sidebar-brown.gif"
              alt="Loading"
            >
          </div>
        `;
      }

      setTimeout(() => {
        S.page = n;
        render();
      }, 1000);
    }
    function setTab(g) {
      // Toggle: clicking the active tab deselects it (back to default)
      S.tab = (S.tab === g) ? '' : g;
      document.querySelectorAll('.tab').forEach(t => t.classList.toggle('active', t.dataset.tab === S.tab));
      go();
    }
    function esc(s) { return String(s ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
    let _acTimer = null;
    let _searchTimer = null;
    document.getElementById('q').addEventListener('input', e => {
      const v = e.target.value;
      clearTimeout(_acTimer);
      clearTimeout(_searchTimer);
      _acTimer = setTimeout(() => renderAutocomplete(v), 130);
      if (v.trim() === '') {
        S.q = ''; S.submitted = false;
        const _al = document.getElementById('ac-list'); if (_al) _al.style.display = 'none';
        go();
      } else {
        // Live search — runs after user pauses typing (debounced 250ms)
        _searchTimer = setTimeout(() => {
          S.q = v.trim(); S.submitted = true; go();
        }, 250);
      }
    });
    document.getElementById('q').addEventListener('blur', () => {
      setTimeout(() => {
        const _al = document.getElementById('ac-list');
        if (_al) _al.style.display = 'none';
      }, 200);
    });
    document.getElementById('q').addEventListener('keydown', e => {
      const _al = document.getElementById('ac-list');
      const _items = _al ? _al.querySelectorAll('.ac-item') : [];
      // Arrow key navigation
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const cur = _al.querySelector('.ac-item.ac-active');
        const arr = [..._items];
        if (!arr.length) return;
        let idx = cur ? arr.indexOf(cur) + (e.key === 'ArrowDown' ? 1 : -1) : 0;
        idx = Math.max(0, Math.min(arr.length - 1, idx));
        arr.forEach(el => el.classList.remove('ac-active'));
        arr[idx].classList.add('ac-active');
        document.getElementById('q').value = arr[idx].querySelector('.ac-label').textContent;
        return;
      }
      if (e.key === 'Escape') { if (_al) _al.style.display = 'none'; return; }
      if (e.key === 'Tab') {
        const suggestion = getFirstSuggestion();
        if (
          suggestion &&
          suggestion.toLowerCase() !== e.target.value.trim().toLowerCase()
        ) {
          e.preventDefault();
          e.target.value = suggestion;
          S.q = suggestion;
          S.submitted = true;
          go();
        }

        return;
      }
      if (e.key === 'Enter') {
        const active = _al && _al.querySelector('.ac-item.ac-active');
        if (active) { active.dispatchEvent(new MouseEvent('mousedown', { bubbles: true })); return; }
        const v = e.target.value.trim();
        if (_al) _al.style.display = 'none';
        // Cancel any pending live search and run immediately
        clearTimeout(_searchTimer);
        S.q = v; S.submitted = !!v; go();
      }
    });
    document.querySelectorAll('.tabs-bar .tab').forEach(t => {
      t.addEventListener('click', () => setTab(t.dataset.tab));
    });
    function initFromUrl() {
      try {
        const sp = new URLSearchParams(window.location.search || '');
        const q = sp.get('q');
        const selectedVendor = sp.get('selected_vendor');
        const hadParams = !!(window.location.search && window.location.search.length > 1);

        if (q && String(q).trim()) {
          const v = String(q).trim();
          const inp = document.getElementById('q');
          if (inp) inp.value = v;
          S.q = v;
          S.submitted = true;
        }

        // Tab deep-linking via ?selected_vendor=man|woman|accessories
        const sv = (selectedVendor == null) ? '' : String(selectedVendor).toLowerCase().trim();
        if (sv && sv !== 'undefined') {
          // Check woman first to avoid 'woman' matching 'man'
          const tab =
            (sv === 'woman' || sv.includes('woman')) ? 'Woman' :
              (sv === 'accessories' || sv === 'accessory' || sv.includes('accessor')) ? 'Accessories' :
                (sv === 'man' || /\bman\b/.test(sv) || sv.startsWith('man')) ? 'Man' :
                  '';
          if (tab) {
            S.tab = tab;
            // Sync UI .active class (no go() — boot will render once data is ready)
            document.querySelectorAll('.tab').forEach(t => t.classList.toggle('active', t.dataset.tab === tab));
          }
        }

        // After first refresh/load, clean URL (remove params)
        if (window.location.pathname.includes('/search')) {
          if (hadParams) {
            const clean = window.location.pathname + (window.location.hash || '');
            window.history.replaceState(null, '', clean);
          }
        }
      } catch (_) { }
    }
    initFromUrl();
    boot(false);
    initGhostSuggestion();
    function initGhostSuggestion() {
      const input = document.getElementById('q');
      if (!input) return;
      if (document.querySelector('.mdv-ghost-suggestion')) return;
      const ghost = document.createElement('div');
      ghost.className = 'mdv-ghost-suggestion';
      input.parentNode.appendChild(ghost);
      window.__ghostEl = ghost;
  }

    function redirectSearchOnEnter() {
      $(document).on('keydown', '#q', function (e) {
        if (e.key !== 'Enter') return;

        // search page par aa code run nahi thase
        if (window.location.pathname === '/search') return;

        var $searchBox = $('.search-desk-box');
        var searchValue = $.trim($('#q').val());
        var activeTab = $.trim($('.tabs-bar .tab.active').data('tab'));

        if ($searchBox.hasClass('active') && searchValue) {
          e.preventDefault();

          var url = '/search?q=' + encodeURIComponent(searchValue);

          // active tab hoy to j add karo
          if (activeTab) {
            url += '&selected_vendor=' + encodeURIComponent(activeTab.toLowerCase());
          }

          window.location.href = url;
        }
      });
    }

    $(document).ready(function () {
      redirectSearchOnEnter();
    });